import type { IEntityParamItem } from '@/types/entityParams';
import type { ISiteAccountParamListRowApi, ISiteAccountParamMutationRow } from '@/types/siteAccountParams';
import { AbstractModel } from './abstractModel';

export class SiteAccountParamItem extends AbstractModel implements IEntityParamItem {
    accountId: number = 0;
    id: number = 0;
    param: string = '';
    value: string = '';

    constructor(data?: ISiteAccountParamListRowApi) {
        super();

        if (data) {
            this.id = data.id;
            this.accountId = data.account_id;
            this.param = data.param;
            this.value = data.value ?? '';
        }
    }

    toCreateApiData(): ISiteAccountParamMutationRow {
        return {
            account_id: this.accountId,
            param: this.param.trim(),
            value: this.formatValue(this.value),
        };
    }

    toUpdateApiData(fields: Array<'param' | 'value'>): ISiteAccountParamMutationRow {
        const row: ISiteAccountParamMutationRow = { id: this.id };

        if (fields.includes('param')) {
            row.param = this.param.trim();
        }

        if (fields.includes('value')) {
            row.value = this.formatValue(this.value);
        }

        return row;
    }

    private formatValue(value: string): string | null {
        const trimmed = value.trim();
        return trimmed === '' ? null : trimmed;
    }
}
